"use client";

import { useEffect } from "react";
import { loadImage } from "@/hooks/files";

interface UseImagePreloadParams {
  srcs: readonly string[];
}

export function useImagePreload({ srcs }: UseImagePreloadParams): void {
  useEffect(() => {
    const abortController = new AbortController();

    void Promise.all(
      srcs.map((src) => loadImage(src, abortController.signal)),
    ).catch(() => undefined);

    return () => {
      abortController.abort();
    };
  }, [srcs]);
}
